// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Search from "./components/Search";
import MDBox from "components/MDBox";

function AdvancedSearch() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Search />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AdvancedSearch;
